import { ResourceProps } from 'libs/contentful/types';
import Link from 'components/shared/Link/Link';
import { cn } from 'utils/styles';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import Media from 'components/shared/Media/Media';

function Resource({
  sys,
  index = 0,
  resourceIcon,
  resourceLabelRte,
  resourceCopy,
  resourcePage,
  url,
  className,
  contentClassName,
  idPrefix,
  aspectRatio,
}: ResourceProps) {
  return (
    <div className={cn('md:flex-auto', className)}>
      <Link className="group" internalPage={resourcePage} href={url} id={`${idPrefix}_link_${index + 1}`}>
        <div className={cn('flex flex-col md:flex-row gap-4 md:grow md:items-start', contentClassName)}>
          {resourceIcon && (
            <div
              className="flex relative aspect-square w-[152px] h-[152px] md:w-[110px] md:h-[110px] items-start"
              {...liveUpdateAttrs(sys?.id, 'resourceIcon')}>
              <Media
                {...(idPrefix != null && { id: `${idPrefix}_image_${index + 1}` })}
                media={{ ...resourceIcon, fill: true }}
                aspectRatio={aspectRatio}
                sizes="(width <= 1024px) 304px, 220px"
                className="rounded-md group-hover:scale-110 transition"
              />
            </div>
          )}
          <div className="flex flex-col gap-2 mt-4 md:mt-0">
            <div
              className="font-serif font-normal text-eyebrow leading-1.4 text-grey-200 in-cw-inverse:text-lettuce in-cw-enterprise-dark-green:text-lettuce in-cw-tertiary:text-kale"
              {...(idPrefix != null && { id: `${idPrefix}_category_${index + 1}` })}
              {...liveUpdateAttrs(sys?.id, 'resourceLabelRte')}>
              <RichTextCopy copy={resourceLabelRte} />
            </div>
            <div
              className="font-sans text-label-saans md:text-body-saans font-medium"
              {...(idPrefix != null && { id: `${idPrefix}_blurb_${index + 1}` })}
              {...liveUpdateAttrs(sys?.id, 'resourceCopy')}>
              {/* Uses Rich Text Headline to prevent new lines from rendering additional space as with RichTextCopy */}
              <RichTextHeadline headline={resourceCopy} level="p" />
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default Resource;
